var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEasyToUse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M505.53 907.54l20-22.06q-10.1 1.46-20.33 2.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M515.32 3.22C271 3.22 72.92 201.3 72.92 445.63c0 237.11 186.52 430.64 420.84 441.89l1.86 98.77c0 .62-.06 1.25-.06 1.89a32.62 32.62 0 0032.6 32.6h.49a32.54 32.54 0 0025.27-12.61l144.44-159.65c153-69.63 259.37-223.83 259.37-402.89 0-244.33-198.07-442.41-442.41-442.41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M464.14 528.62l-6.14-6.14-96.67-96.67A37.63 37.63 0 00308.12 479l129.42 129.44a37.61 37.61 0 0053.2 0l231.79-231.79a37.63 37.63 0 00-53.21-53.21l-199 199z"
  })));
}

export default SvgEasyToUse;